import type React from "react";
import { Link } from "react-router-dom";

interface DropdownItemProps {
  tag?: "a" | "button";
  to?: string;
  onClick?: () => void;
  onItemClick?: () => void;
  baseClassName?: string;
  className?: string;
  children: React.ReactNode;
  active?: boolean;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
  tag = "button",
  to,
  onClick,
  onItemClick,
  baseClassName = "block w-full text-left px-4 py-2 text-sm transition-colors duration-200 rounded-md",
  className = "",
  children,
  active = false,
}) => {
  const combinedClasses = `${baseClassName} ${className} group ${
    active ? "bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white" : ""
  }`.trim();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent event from bubbling up to parent elements (e.g., table rows)
    if (tag === "button") {
      event.preventDefault();
    }
    if (onClick) onClick();
    if (onItemClick) onItemClick();
  };

  if (tag === "a" && to) {
    return (
      <Link
        to={to}
        className={`${combinedClasses} 
          hover:bg-gray-100 hover:text-gray-900 
          dark:hover:bg-gray-700 dark:hover:text-white`}
        onClick={handleClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      onClick={handleClick}
      className={`${combinedClasses} 
        hover:bg-gray-100 hover:text-gray-900 
        dark:hover:bg-gray-700 dark:hover:text-white`}
    >
      {children}
    </button>
  );
};
